import { withBemMod } from '@bem-react/core';
import { cnButton } from '@yandex-int/hr-components/Button';

import './Button_view_legal_secondary.css';

export type WithViewLegalSecondaryProps = {
    view?: 'legal_secondary';
};

export const withViewLegalSecondary = withBemMod<WithViewLegalSecondaryProps>(cnButton(), {
    view: 'legal_secondary',
});
